/**
 * StreamRift View - Password-gated command center.
 *
 * SessionStorage gate: unlocked per tab, re-prompts on refresh.
 * Completely isolated from other views.
 */

import { useState } from 'react';
import { StreamRiftGate } from './StreamRiftGate';
import { EyeOfStreamRift } from './EyeOfStreamRift';

export function StreamRiftView() {
  const [unlocked, setUnlocked] = useState(
    () => sessionStorage.getItem('streamrift_unlocked') === 'true'
  );

  if (!unlocked) {
    return <StreamRiftGate onUnlock={() => setUnlocked(true)} />;
  }

  return <EyeOfStreamRift />;
}
